import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
var MLLogsService = /** @class */ (function (_super) {
    tslib_1.__extends(MLLogsService, _super);
    function MLLogsService(http) {
        var _this = _super.call(this, http, MapperService.mlLogMap) || this;
        _this._endpoint = '/odata/MLLogs';
        return _this;
    }
    return MLLogsService;
}(ODataService));
export { MLLogsService };
